import { createPortal } from "react-dom";
import { useEffect, useState, type ReactNode } from "react";

export function TopBarPortal({ children }: { children: ReactNode }) {
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setTarget(document.getElementById("signals-topbar-actions"));
  }, []);

  return target ? createPortal(children, target) : null;
}
